export default __webpack_public_path__ + "static/media/cardboard_study_5.64dbe3ec.jpg";